export default "__VITE_ASSET__BoWHrc1V__"